(function () {
  const urlParams = new URLSearchParams(window.location.search);
  const cartDiscountsString = document.querySelector("#cart_discounts").innerText.replace(/(\r\n|\n|\r)/gm, "").replace(/ /g, '');

  let cartDiscounts;
  let currentPageType = '';

  if (cartDiscountsString.endsWith(',')) {
    cartDiscounts = JSON.parse('[' + cartDiscountsString.slice(0, -1) + ']');
  } else {
    cartDiscounts = [];
  }

  function setCookie(name, value, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
  }

  if (cartDiscounts && cartDiscounts.length > 0) {
    cartDiscounts.forEach(cartDiscount => {
      if (cartDiscount.handle.includes("secret")) {
        const discountParams = cartDiscount.handle.split("_");
        const discountSourceType = discountParams[0].replace("secret", "");
        const discountDetails = {
          sourceType: discountSourceType === "p" ? "product" : "collection",
          handle: discountParams[1],
          amount: discountParams[2]
        }
        setCookie('voo_discount', JSON.stringify(discountDetails), 10);
      }
    });
  }

  if (window.location.pathname.includes("products/")) {
    currentPageType = 'product';
  } else if (window.location.pathname.includes("collections/")) {
    currentPageType = 'collection';
  }

  if (urlParams.get("discount")) {
    const discountParams = urlParams.get("discount").split("_");
    if (discountParams.length !== 3 || !parseInt(discountParams[2])) return;

    const discountSourceType = discountParams[0].replace("secret", "");
    const discountDetails = {
      sourceType: discountSourceType === "p" ? "product" : "collection",
      handle: discountParams[1],
      amount: discountParams[2]
    }

    fetch(`${window.Shopify.routes.root}discount/${urlParams.get("discount")}`)
      .then(() => {
        setCookie('voo_discount', JSON.stringify(discountDetails), 10);
        if (currentPageType !== '') {
          renderBadge(discountDetails);
        }
      })
      .catch(error => console.error(error))
  } else {
    const savedDiscount = getCookie("voo_discount");
    if (currentPageType !== '' && savedDiscount && savedDiscount !== '') {
      renderBadge(JSON.parse(savedDiscount));
    }
  }

  function renderBadge(discount) {
    if (!discount || !parseInt(discount.amount)) return;
    const discountText = `Save ${discount.amount}% in checkout`;

    if (currentPageType === "product") {
      const productWrapper = document.querySelector(".product[data-handle]");
      if (discount.sourceType === "collection") {
        const productAllCollections = productWrapper.dataset.collections.split(',');
        let isInCollection = false;
        productAllCollections.forEach(collection => {
          if (collection.includes(discount.handle)) {
            isInCollection = true;
          }
        });

        if (isInCollection) {
          productWrapper.querySelectorAll(".voo-discount").forEach(discountBlock => {
            discountBlock.innerText = discountText;
          })
        }
      } else if (discount.sourceType === "product") {
        productWrapper.querySelectorAll(".voo-discount").forEach(discountBlock => {
          discountBlock.innerText = discountText;
        })
      }
    } else if (currentPageType == "collection") {
      const collectionGrid = document.querySelector("#ProductGridContainer");
      if (discount.sourceType === "collection" && collectionGrid.dataset.handle.includes(discount.handle)) {
        collectionGrid.querySelectorAll(".voo-discount").forEach(discountBlock => {
          discountBlock.innerText = discountText;
        })
        collectionGrid.querySelectorAll(".hc-sale-tag, .preorder-label").forEach(el => el.style.display = "none");
      }
    }
  }


  function getCookie(cookiename) {
    let name = cookiename + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return false;
  }
})()
